import http from '@/api/ajax.js' //ajax请求

const state={
  deptId:'', // 部门，渠道id
  currentNode:'', // 当前选中的树节点内容
  orgTree:'', // 整个组织树的内容
  orgLoading:false, // 加载组织树时页面的loading
  currentNodeLevel:'', // 当前选中的节点层级
  permission:[], // 权限列表
}
const mutations = {
  SET_DEPTID: (state, DEPTID) => {
    state.deptId = DEPTID;
    sessionStorage.DEPTID = DEPTID;
  },
  SET_CURRENTNODE: (state, CURRENTNODE) => {
    state.currentNode = CURRENTNODE;
    sessionStorage.CURRENTNODE = CURRENTNODE;
  },
  SET_TREE: (state, TREE) => {
    state.orgTree = TREE;
    sessionStorage.TREE = TREE;
  },
  SET_ORGLOADING: (state, ORGLOADING) => {
    state.orgLoading = ORGLOADING;
    sessionStorage.ORGLOADING = ORGLOADING;
  },
  SET_CURRENTNODELEVEL: (state, CURRENTNODELEVEL) => {
    state.currentNodeLevel = CURRENTNODELEVEL;
    sessionStorage.CURRENTNODELEVEL = CURRENTNODELEVEL;
  },
  SET_PERMISSION(state, PERMISSION){
    state.permission = PERMISSION
  }
}

const actions = {
  // 获取用户权限
  getUserPermission({ commit,state }){
    return http({
      url:'/master/mechanRole/getUserPermission',
      type:'get',
      params: {}
    }).then((res)=>{
      commit('SET_PERMISSION', res.data);
    })
  },
}
export default {
  namespaced: false,
  state,
  mutations,
  actions,
}